
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/execution",
      function () {
        return require("private-next-pages/execution.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/execution"])
      });
    }
  